export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
}

export interface ComicChapter {
  id: number;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: ComicChapter[];
  updateDate: string;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export const comicCategories: ComicCategory[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '热血', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
  { slug: 'horror', name: '惊悚', icon: 'ri-ghost-line' },
  { slug: 'school', name: '校园', icon: 'ri-building-line' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '霸道总裁的契约新娘',
    author: '金秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20style%2C%20elegant%20couple%20in%20modern%20setting%2C%20soft%20warm%20lighting%2C%20manga%20style%20illustration%2C%20clean%20background%2C%20professional%20digital%20art%2C%20romantic%20atmosphere&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '一个平凡的女孩，因为一纸契约，成为了霸道总裁的未婚妻。原本以为只是一场交易，却在朝夕相处中，两颗心渐渐靠近。当真相浮出水面，他们的爱情将何去何从？这部韩国漫画以其细腻的情感描绘和精美的画风，吸引了无数读者的关注与喜爱。',
    category: 'romance',
    tags: ['恋爱', '总裁', '契约婚姻', '都市'],
    status: '连载中',
    rating: 4.8,
    views: 1250000,
    chapters: [
      { id: 1, title: '第1话 命运的相遇', updateDate: '2026-08-01' },
      { id: 2, title: '第2话 契约签订', updateDate: '2026-08-02' },
      { id: 3, title: '第3话 同居生活', updateDate: '2026-08-03' },
      { id: 4, title: '第4话 心动瞬间', updateDate: '2026-08-04' },
    ],
    updateDate: '2026-08-04',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 2,
    title: '剑与魔法的异世界',
    author: '李智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20warrior%20with%20magical%20sword%20in%20fantasy%20world%2C%20epic%20atmosphere%2C%20digital%20illustration%2C%20clean%20background%2C%20professional%20anime%20style%20art&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '普通高中生李浩在一次意外中穿越到了充满魔法与剑的异世界。在这里，他发现自己拥有独一无二的能力——可以同时掌握剑术与魔法。面对黑暗势力的威胁，他必须快速成长，保护这个新的家园。一场波澜壮阔的异世界冒险就此展开！',
    category: 'fantasy',
    tags: ['奇幻', '异世界', '冒险', '魔法'],
    status: '连载中',
    rating: 4.9,
    views: 2100000,
    chapters: [
      { id: 1, title: '第1话 穿越异世界', updateDate: '2026-07-28' },
      { id: 2, title: '第2话 觉醒之力', updateDate: '2026-07-30' },
      { id: 3, title: '第3话 初次战斗', updateDate: '2026-08-02' },
    ],
    updateDate: '2026-08-02',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 3,
    title: '校园的秘密花园',
    author: '朴智敏',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20cover%2C%20students%20in%20cherry%20blossom%20campus%2C%20youthful%20fresh%20atmosphere%2C%20digital%20illustration%2C%20clean%20bright%20background%2C%20anime%20style%20art&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '樱花高中有一个传说：在校园后山的秘密花园里许愿，愿望就会实现。转学生小雅在一次偶然中发现了这个秘密花园，也遇到了那个改变她一生的少年。青春、友情、朦胧的爱情，在这片秘密花园中悄然绽放。',
    category: 'school',
    tags: ['校园', '青春', '恋爱', '治愈'],
    status: '已完结',
    rating: 4.7,
    views: 890000,
    chapters: [
      { id: 1, title: '第1话 转学生', updateDate: '2026-06-10' },
      { id: 2, title: '第2话 秘密花园', updateDate: '2026-06-15' },
      { id: 3, title: '第3话 初次交谈', updateDate: '2026-06-20' },
      { id: 4, title: '第4话 许愿', updateDate: '2026-06-25' },
      { id: 5, title: '第5话 最终话 告白', updateDate: '2026-07-01' },
    ],
    updateDate: '2026-07-01',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 4,
    title: '暗夜追踪者',
    author: '崔成宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20noir%20cover%2C%20detective%20in%20dark%20city%20alley%2C%20mysterious%20moody%20atmosphere%2C%20digital%20illustration%2C%20dark%20background%2C%20professional%20anime%20art&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '深夜的都市，连环案件频发。退役刑警韩东秀重出江湖，凭借敏锐的直觉和丰富的经验，一步步揭开案件背后的惊天阴谋。每一个线索都指向一个更大的谜团，而真相远比想象的更加残酷。',
    category: 'thriller',
    tags: ['悬疑', '推理', '都市', '犯罪'],
    status: '连载中',
    rating: 4.6,
    views: 670000,
    chapters: [
      { id: 1, title: '第1话 深夜来电', updateDate: '2026-07-20' },
      { id: 2, title: '第2话 第一现场', updateDate: '2026-07-25' },
      { id: 3, title: '第3话 蛛丝马迹', updateDate: '2026-08-01' },
    ],
    updateDate: '2026-08-01',
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 5,
    title: '美食征服异世界',
    author: '姜美娜',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cooking%20cover%2C%20chef%20with%20delicious%20food%20in%20fantasy%20setting%2C%20warm%20colorful%20atmosphere%2C%20digital%20illustration%2C%20clean%20background%2C%20anime%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '米其林三星主厨意外穿越到异世界，发现这里的美食文化还停留在原始阶段。凭借精湛的厨艺，他决定在这个世界掀起一场美食革命。没想到，美味的料理不仅征服了异世界居民的胃，还意外地成为了他最强的武器！',
    category: 'comedy',
    tags: ['搞笑', '美食', '异世界', '冒险'],
    status: '连载中',
    rating: 4.5,
    views: 540000,
    chapters: [
      { id: 1, title: '第1话 穿越到美食荒漠', updateDate: '2026-07-15' },
      { id: 2, title: '第2话 第一道菜', updateDate: '2026-07-22' },
      { id: 3, title: '第3话 美食的力量', updateDate: '2026-07-29' },
    ],
    updateDate: '2026-07-29',
    isHot: false,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 6,
    title: '重生之复仇女王',
    author: '尹恩惠',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20revenge%20cover%2C%20elegant%20woman%20in%20luxury%20setting%2C%20dramatic%20lighting%2C%20digital%20illustration%2C%20clean%20background%2C%20professional%20anime%20art&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '被最信任的人背叛，含恨而死的商界女王，竟然重生回到了二十年前！带着前世所有的记忆，她发誓要让那些伤害过她的人付出代价。这一次，她不再是任人宰割的羔羊，而是运筹帷幄的复仇女王。',
    category: 'drama',
    tags: ['剧情', '重生', '复仇', '商战'],
    status: '连载中',
    rating: 4.9,
    views: 1880000,
    chapters: [
      { id: 1, title: '第1话 含恨而终', updateDate: '2026-07-18' },
      { id: 2, title: '第2话 重回二十年前', updateDate: '2026-07-22' },
      { id: 3, title: '第3话 布局开始', updateDate: '2026-07-28' },
      { id: 4, title: '第4话 初次交锋', updateDate: '2026-08-03' },
    ],
    updateDate: '2026-08-03',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 7,
    title: '鬼怪医院',
    author: '张贤宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20cover%2C%20abandoned%20hospital%20with%20ghostly%20figures%2C%20dark%20eerie%20atmosphere%2C%20digital%20illustration%2C%20clean%20dark%20background%2C%20horror%20anime%20art&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '在城市郊外，有一座废弃多年的医院。传说每到午夜，医院里就会传出诡异的声音。一群不信邪的年轻人决定夜探鬼楼，却不知道等待他们的，是超乎想象的恐怖。每一个深夜，都有人悄然消失……',
    category: 'horror',
    tags: ['惊悚', '恐怖', '都市传说', '灵异'],
    status: '连载中',
    rating: 4.4,
    views: 430000,
    chapters: [
      { id: 1, title: '第1话 废弃医院', updateDate: '2026-07-10' },
      { id: 2, title: '第2话 午夜探秘', updateDate: '2026-07-17' },
      { id: 3, title: '第3话 第一个消失的人', updateDate: '2026-07-24' },
    ],
    updateDate: '2026-07-24',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 8,
    title: '猫咪咖啡厅的日常',
    author: '宋智孝',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%2C%20cute%20cat%20cafe%20with%20warm%20cozy%20atmosphere%2C%20digital%20illustration%2C%20soft%20pastel%20colors%2C%20clean%20background%2C%20healing%20anime%20art&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '在一条安静的小巷里，有一家名为"喵时光"的猫咪咖啡厅。这里不仅是流浪猫的温暖港湾，也是都市人放松心灵的治愈空间。每一位走进咖啡厅的客人，都带着各自的故事，而猫咪们用它们独特的方式，温暖着每一个疲惫的灵魂。',
    category: 'daily',
    tags: ['日常', '治愈', '猫咪', '温馨'],
    status: '连载中',
    rating: 4.8,
    views: 760000,
    chapters: [
      { id: 1, title: '第1话 欢迎光临', updateDate: '2026-07-05' },
      { id: 2, title: '第2话 第一位客人', updateDate: '2026-07-12' },
      { id: 3, title: '第3话 小橘的故事', updateDate: '2026-07-19' },
      { id: 4, title: '第4话 雨天的相遇', updateDate: '2026-07-26' },
    ],
    updateDate: '2026-07-26',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 9,
    title: '热血格斗传说',
    author: '郑宇成',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fighting%20cover%2C%20martial%20artist%20in%20dynamic%20pose%2C%20intense%20energy%20atmosphere%2C%20digital%20illustration%2C%20clean%20background%2C%20professional%20anime%20art&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '从小被武术大师收养的少年金泰洙，怀揣着成为最强格斗家的梦想。在高手云集的格斗大赛中，他不断挑战自我，突破极限。每一场战斗都是生与死的较量，每一次胜利都是用汗水和鲜血换来的。这就是热血格斗的传说！',
    category: 'action',
    tags: ['热血', '格斗', '竞技', '成长'],
    status: '连载中',
    rating: 4.7,
    views: 980000,
    chapters: [
      { id: 1, title: '第1话 少年的梦想', updateDate: '2026-07-08' },
      { id: 2, title: '第2话 初入赛场', updateDate: '2026-07-15' },
      { id: 3, title: '第3话 第一场胜利', updateDate: '2026-07-22' },
      { id: 4, title: '第4话 强敌出现', updateDate: '2026-07-29' },
    ],
    updateDate: '2026-07-29',
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 10,
    title: '穿越成反派大小姐',
    author: '韩素希',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20villainess%20cover%2C%20elegant%20noblewoman%20in%20historical%20fantasy%20setting%2C%20dramatic%20romantic%20atmosphere%2C%20digital%20illustration%2C%20clean%20background%2C%20professional%20anime%20art&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '一觉醒来，普通上班族林娜发现自己穿越成了小说里的反派大小姐！按照原著剧情，她将在三个月后被主角团消灭。为了改变命运，林娜决定改写剧情。可没想到，她的"反派行为"却让所有人爱上了她？这部韩国漫画爆笑又温馨！',
    category: 'fantasy',
    tags: ['奇幻', '穿越', '恋爱', '搞笑'],
    status: '连载中',
    rating: 4.8,
    views: 1560000,
    chapters: [
      { id: 1, title: '第1话 醒来成了反派', updateDate: '2026-07-12' },
      { id: 2, title: '第2话 改变命运的第一步', updateDate: '2026-07-18' },
      { id: 3, title: '第3话 意外的好感', updateDate: '2026-07-25' },
      { id: 4, title: '第4话 剧情完全乱套', updateDate: '2026-08-01' },
    ],
    updateDate: '2026-08-01',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 11,
    title: '异能者的日常',
    author: '刘在石',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20superpower%20comedy%20cover%2C%20teenagers%20with%20special%20abilities%20in%20modern%20city%2C%20bright%20humorous%20atmosphere%2C%20digital%20illustration%2C%20clean%20background%2C%20anime%20art&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '在这个世界上，有一小部分人天生拥有超能力。但拥有超能力并不意味着可以成为超级英雄——你还是要上学、考试、找工作。这部韩国漫画以幽默诙谐的方式，讲述了几个异能高中生的爆笑日常，让人捧腹大笑的同时又感同身受。',
    category: 'comedy',
    tags: ['搞笑', '异能', '校园', '日常'],
    status: '连载中',
    rating: 4.6,
    views: 720000,
    chapters: [
      { id: 1, title: '第1话 超能力觉醒', updateDate: '2026-07-01' },
      { id: 2, title: '第2话 异能者也要考试', updateDate: '2026-07-08' },
    ],
    updateDate: '2026-07-08',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 12,
    title: '月光下的约定',
    author: '金泰妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20moonlight%20cover%2C%20couple%20under%20moonlit%20night%20sky%2C%20romantic%20dreamy%20atmosphere%2C%20digital%20illustration%2C%20soft%20clean%20background%2C%20beautiful%20anime%20art&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '十年前，他们在月光下许下了永远的约定。十年后，命运让他们再次相遇，却已物是人非。他成了当红偶像，而她是默默无闻的插画师。那段尘封的记忆，那个月光下的约定，是否还能实现？',
    category: 'romance',
    tags: ['恋爱', '青梅竹马', '娱乐圈', '治愈'],
    status: '已完结',
    rating: 4.8,
    views: 1020000,
    chapters: [
      { id: 1, title: '第1话 重逢', updateDate: '2026-05-20' },
      { id: 2, title: '第2话 记忆中的月光', updateDate: '2026-05-25' },
      { id: 3, title: '第3话 身份的差距', updateDate: '2026-05-30' },
      { id: 4, title: '第4话 最终话 约定实现', updateDate: '2026-06-10' },
    ],
    updateDate: '2026-06-10',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
];

export const siteInfo = {
  name: '韩漫网站',
  tagline: '韩国漫画免费在线阅读 - 下拉式韩漫尽在掌握',
  description: '我们致力于为中国读者提供最优质的韩国漫画免费在线阅读服务。采用下拉式阅读方式，让您随时随地畅享韩漫的乐趣。平台收录了大量好看的韩国漫画，涵盖恋爱、奇幻、热血、悬疑等多种类型，是您发现热门韩漫作品的最佳选择。',
  email: 'contact@hanmanwangzhan.com',
  founded: '2020年',
  totalComics: '5000+',
  dailyVisitors: '100万+',
  features: [
    {
      title: '免费阅读',
      description: '所有韩国漫画均可免费在线阅读，无需付费，让每位读者都能畅享韩漫的精彩世界。',
      icon: 'ri-money-cny-circle-line',
    },
    {
      title: '下拉式阅读',
      description: '采用下拉式韩漫阅读体验，流畅顺滑的滚动翻页，让您沉浸在漫画的精彩故事中。',
      icon: 'ri-scroll-to-bottom-line',
    },
    {
      title: '海量资源',
      description: '收录5000+部韩国漫画作品，每日持续更新，漫画大全会不断扩充，总有您喜欢的作品。',
      icon: 'ri-book-open-line',
    },
    {
      title: '高清画质',
      description: '所有漫画均采用高清画质呈现，每一笔线条都清晰可见，带来极致的视觉享受。',
      icon: 'ri-hd-line',
    },
    {
      title: '每日更新',
      description: '热门韩国漫画每日更新最新章节，追更不等待，第一时间阅读最新剧情发展。',
      icon: 'ri-calendar-check-line',
    },
    {
      title: '多端支持',
      description: '支持电脑、平板、手机多端在线同步阅读，随时随地继续您的漫画之旅。',
      icon: 'ri-device-line',
    },
  ],
  testimonials: [
    {
      name: '小王',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20simple%20clean%20background%2C%20friendly%20smile%2C%20casual%20style%2C%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish',
      comment: '这个韩漫网站的体验真的太棒了！下拉式阅读非常流畅，漫画资源也超级全。我几乎每天都在这里追更，已经成为我的必备阅读平台了。',
      rating: 5,
    },
    {
      name: '小美',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20simple%20clean%20background%2C%20warm%20smile%2C%20casual%20style%2C%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
      comment: '终于找到一个可以免费看韩国漫画的网站了！分类非常清楚，找漫画特别方便。恋爱类的韩漫真的太甜了，每天必看几话才能入睡。',
      rating: 5,
    },
    {
      name: '阿杰',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20simple%20clean%20background%2C%20confident%20look%2C%20casual%20fashion%2C%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish',
      comment: '作为漫画爱好者，这个韩国漫画网站的画质让我非常满意。高清呈现每一幅画面，阅读体验完全不输付费平台。强烈推荐！',
      rating: 5,
    },
  ],
  faqs: [
    {
      question: '这个韩漫网站真的可以免费阅读吗？',
      answer: '是的，我们平台的所有韩国漫画均免费提供在线阅读服务。您无需支付任何费用，即可畅享下拉式韩漫的精彩内容。我们通过广告收入维持运营，为广大用户提供优质的免费阅读体验。',
    },
    {
      question: '什么是下拉式韩漫阅读方式？',
      answer: '下拉式韩漫是韩国漫画特有的一种阅读形式，通过向下滚动页面来阅读漫画，画面纵向排列，阅读体验流畅自然。这种方式特别适合在手机等移动设备上在线浏览漫画，让您可以轻松享受韩国漫画的乐趣。',
    },
    {
      question: '漫画大全包含哪些类型的作品？',
      answer: '我们的漫画大全涵盖了恋爱、奇幻、热血、悬疑、搞笑、剧情、日常、惊悚、校园等多种类型。无论您喜欢什么风格的韩国漫画，都能在这里找到心仪的作品。平台每日更新，持续丰富漫画资源。',
    },
    {
      question: '需要注册账号才能在线观看吗？',
      answer: '不需要。您可以直接访问我们的韩漫网站，无需注册即可免费在线阅读所有漫画。我们致力于为您提供最便捷的阅读体验，点击即看，方便快捷。',
    },
    {
      question: '漫画更新频率如何？',
      answer: '热门连载漫画通常每周更新1-2话，具体更新频率取决于作品的连载进度。我们会在第一时间同步更新最新章节，让您追更不等待。',
    },
  ],
};